<template>
  <div class="bg-darkmode-important" style="background-color: #f5f6fa; border-radius: 0 0 5px 0">
    <div class="flex-1 pr-30">
      <h6 class="strong">{{ $t("text.popup_text_settings") }}</h6>

      <div class="flex items-center my-15">
        <h6 class="mb-0 mr-20">{{ $t("text.link_text") }}</h6>
        <div class="flex-1">
          <TextField class="block bg-white font-h6 mt-0" v-model="link_text" />
        </div>
      </div>

      <!-- ////////////////// -->

      <h6 class="strong">{{ $t("text.booking_settings_for_text") }}</h6>
      <p class="font-body">{{ $t("text.customize_the_booking_page_look") }}</p>

      <div class="my-10 mt-20">
        <Checkbox label="Hide Event Type Details" :isChecked="s_hide" :labelable="true" @checkboxChange="s_hide = !s_hide" />
      </div>

      <div class="flex items-center my-15">
        <h6 class="mb-0 flex-1">{{ $t("text.background_color") }}</h6>
        <SelectColor v-model="s_bg" />
      </div>

      <div class="flex items-center my-15">
        <h6 class="mb-0 flex-1">{{ $t("text.text_color") }}</h6>
        <SelectColor v-model="s_text" />
      </div>

      <div class="flex items-center my-15">
        <h6 class="mb-0 flex-1">{{ $t("text.button_link_color") }}</h6>
        <SelectColor v-model="s_link" />
      </div>
    </div>
    <div class="flex-1">
      <div class="shadow bg-white mb-20">
        <div class="bg-white bg-white-darkmode p-20">
          <p class="mb-5 color-lightsteel">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut</p>
          <p style="color: blue">{{ link_text }}</p>
          <p class="mt-5 color-lightsteel">Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat</p>
        </div>
        <div class="align-right flex items-center items-end p-5 color-lightsteel bg-light">
          <i class="la la-wifi big-text mr-5"></i>
          <i class="la la-calendar big-text mr-5"></i>
          <i class="la la-usb big-text mr-5"></i>
        </div>
      </div>

      <h6 class="strong">{{ $t("text.embed_code") }}</h6>
      <h6>{{ $t("text.place_html_weezly_appear") }}</h6>

      <textarea readonly class="code-display my-15" style="height: 276px; word-break: break-all">{{ htmlCode }}</textarea>

      <div class="align-right">
        <button class="btn btn-primary font-h6" v-ripple @click="copyCode">{{ $t("button.copy_code") }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import SelectColor from "@/components/Scheduling/Events/SelectColor";
import { copyClipboard } from "@/helpers/functions.js";
export default {
  name: "ShareText",
  components: {
    SelectColor,
  },
  props: {},
  data: function () {
    return {
      link_text: this.$t("text.schedule_time_with_me"),
      s_hide: false,
      s_bg: "#FFFFFF",
      s_text: "#000000",
      s_link: "#0090FF",
    };
  },
  computed: {
    settings() {
      return this.$store.getters.getSchedulingSettings;
    },
    htmlCode() {
      return `<!-- ${this.$Brand} popup widget begin -->
<script src="${this.domain}/external/scheduling.js" type="text/javascript" async><\/script>
<a href="#" onclick="weezly_OpenPopup('${this.external_link}/${this.settings.link}','${
        this.s_hide
      }','${this.s_bg.substring(1)}','${this.s_text.substring(1)}','${this.s_link.substring(1)}'); return false;">${this.link_text}</a>
<!-- ${this.$Brand} popup widget end -->`;
    },
  },
  async mounted() {},
  methods: {
    copyCode() {
      copyClipboard(this.htmlCode);
      this.$root.$emit("alert", this.$t("alert.code_copied"));
    },
  },
};
</script>
